<template>
  <div class="footer">
    <div>
      薛老师自动变速器技术（北京）有限公司<br/>薛神驾到 | Copyright © 2015 - {{ new Date().getFullYear() }}
    </div>
  </div>
</template>

<script>
export default {
  name: "aui-footer"
}
</script>

<style scoped>
.footer {
  font-size: 12px;
  color: #b3b3b3;
  margin-top: 13px;
}

@media only screen and (max-width: 600px) {
  .footer {
    display: none;
  }
}
</style>
